import React, { useEffect } from 'react';
import { IAncillaryGroup } from '../../../../domain/ancillary/domain/models/IAncillaryGroup';
import { trackViewAncillaries } from '../../shared/analytics/e-commerce/trackViewAncillaries';
import { IAncillaryGroupLevel } from '../nested-input';
import { OptionGroup } from '../option';
import { adaptAncillaryGroupToOptionGroup } from './adapters/adaptAncillaryGroupToOptionGroup';

interface IAncillaryGroupOptions {
	ancillaryGroup: IAncillaryGroup;
	nestedInputLevel: IAncillaryGroupLevel;
}

export const AncillaryGroupOptionGroup = ({
	ancillaryGroup,
	nestedInputLevel,
}: IAncillaryGroupOptions) => {
	useEffect(() => {
		trackViewAncillaries(ancillaryGroup.ancillaries);
	}, [ancillaryGroup.ancillaries]);

	const optionGroup = adaptAncillaryGroupToOptionGroup(
		ancillaryGroup,
		nestedInputLevel,
	);

	return <OptionGroup optionGroup={optionGroup} />;
};
